import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  creditNotes : [],
  loading : false,
  outDated : true,
  page : 0,
  pages : 1, //nombre de page total
  per_page : 100,
  mode : 'list',
  count : 0,
  search : '',
  filters : {

  },
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  orderBy:{orderName : 'created_at',  direction:'DESC'},
  selectedCreditNote : null

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
